import { createContext } from '@kne/global-context';

const { Provider, useContext, context } = createContext({});

export { Provider, useContext };

export default context;
